// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"Link_linkContainer__2-6Gj","plainLink":"Link_plainLink__1tjT4","link":"Link_link__2hgXy","socialLink":"Link_socialLink__1mzNv"};